export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface OperatingHours {
  start: string;
  end: string;
}

export type OperatingHoursMap = Partial<Record<DayOfWeek, OperatingHours>>;

export interface OperatingHoursValidatorConfig {
  dayControlName: string;
  timeControlNames: Array<string>;
  hours?: OperatingHoursMap;
  deriveDayFromDate?: boolean;
}
